import ChatCreateDirect from '@/screens/ChatCreateDirect';

export default function PrivateChatCreateDirectIndexRoute() {
  return <ChatCreateDirect />;
}
